import { render, staticRenderFns } from "./ProfilePerformance.vue?vue&type=template&id=00959f85&lang=pug&"
import script from "./ProfilePerformance.vue?vue&type=script&lang=js&"
export * from "./ProfilePerformance.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePerformance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports